import { Reveal } from "@components/ui";
import invoiceImage from "@assets/images/Frame-1618869675@2x.png";

/* ─── Data ─── */

const invoiceItems = [
  { label: "Gas Consumption", value: "AED 35 / m³" },
  { label: "Billing / Admin Fee", value: "AED 20 / invoice" },
  { label: "VAT", value: "5%" },
  { label: "Late Payment Fee", value: "AED 35" },
];

const deliveryMethods = [
  "SMS notification",
  "Email delivery",
  "Customer Portal access",
  "WhatsApp",
];

/* ─── Component ─── */

export function MonthlyInvoiceSection() {
  return (
    <section className="w-full bg-[#f6f6f9] py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/[0.08] text-[#122d63] text-[13px] font-semibold tracking-[-0.02em] uppercase">
              Invoice Details
            </span>
            <h2 className="text-center text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] leading-[1.1]">
              Your Monthly Invoice
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          {/* Left — invoice breakdown */}
          <Reveal direction="up">
            <div className="rounded-[16px] md:rounded-[24px] bg-white p-6 md:p-8 lg:p-10 border border-[#e8e9ed]">
              <h3 className="text-[18px] md:text-[22px] lg:text-[28px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans mb-6 md:mb-8">
                Standard Charges
              </h3>
              <div className="flex flex-col gap-0">
                {invoiceItems.map((item) => (
                  <div
                    key={item.label}
                    className="flex items-center justify-between py-4 md:py-5 border-b border-[#e8e9ed] last:border-b-0"
                  >
                    <span className="text-[14px] md:text-[16px] lg:text-[18px] tracking-[-0.04em] text-[#62636c] font-albert-sans">
                      {item.label}
                    </span>
                    <span className="text-[14px] md:text-[16px] lg:text-[18px] tracking-[-0.04em] font-semibold text-[#1c1c1c] font-albert-sans">
                      {item.value}
                    </span>
                  </div>
                ))}
              </div>

              {/* Delivery methods */}
              <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-[#e8e9ed]">
                <h4 className="text-[16px] md:text-[18px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans mb-4">
                  Invoice Delivery
                </h4>
                <div className="flex flex-col gap-2.5">
                  {deliveryMethods.map((method) => (
                    <div key={method} className="flex items-center gap-2.5">
                      <div className="w-2 h-2 rounded-full bg-[#f24d2b] shrink-0" />
                      <span className="text-[14px] md:text-[15px] lg:text-[16px] tracking-[-0.04em] leading-[1.5] text-[rgba(10,14,46,0.75)] font-albert-sans">
                        {method}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          {/* Right — image */}
          <Reveal direction="up" delay={200} className="flex justify-center">
            <img
              src={invoiceImage}
              alt="Sample invoice"
              className="w-full max-w-[480px] rounded-[16px] md:rounded-[24px] object-contain"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
